import { Column, ModelBase } from 'loca-boot-core'
import { ResourcesModel } from './recommend.model'

export class ResourcesVehicleModel extends ModelBase {
  /**
   * 生效时间描述
   */
  @Column({ name: 'effective_time_desc' })
  public effectiveTimeDesc!: string

  /**
   * 生效规则描述
   */
  @Column({ name: 'effective_rule_desc' })
  public effectiveRuleDesc!: string

  /**
   * 车型code
   */
  @Column()
  public model!: string

  /**
   * 车款code
   */
  @Column()
  public generation!: string

  /**
   * 车名称
   */
  @Column({ name: 'car_name' })
  public carName!: string

  /**
   * 车图片
   */
  @Column()
  public picture!: string

  /**
   * 外观颜色描述
   */
  @Column()
  public color!: string

  /**
   * 外观颜色icon
   */
  @Column({ name: 'color_icon' })
  public colorIcon!: string

  /**
   * 轮毂描述
   */
  @Column()
  public hub!: string

  /**
   * 轮毂icon
   */
  @Column({ name: 'hub_icon' })
  public hubIcon!: string

  /**
   * 内饰描述
   */
  @Column()
  public interior!: string

  /**
   * 内饰描述icon
   */
  @Column({ name: 'interior_icon' })
  public interiorIcon!: string

  /**
   * 内饰
   */
  @Column()
  public material!: string

  /**
   * 内饰icon
   */
  @Column({ name: 'material_icon' })
  public materialIcon!: string
}

// 交接队列
export class TransferSiteGroupItem extends ModelBase {
  @Column({ name: 'transfer_group_code' })
  public transferGroupCode!: string

  @Column({ name: 'transfer_group_name' })
  public transferGroupName!: string
}

export class OutletsModel extends ModelBase {
  @Column()
  public id!: string

  /**
   * 资源名称
   */
  @Column()
  public name!: string

  /**
   * 地址
   */
  @Column()
  public address!: string

  /**
   * 导航距离
   */
  @Column()
  public distance!: string

  /**
   * 店铺方位
   */
  @Column({ name: 'store_position' })
  public storePosition!: string

  /**
   * 资源点类型
   */
  @Column({ name: 'point_type' })
  public pointType!: string

  /**
   * 资源点子类型
   */
  @Column({ name: 'point_sub_type' })
  public pointSubType!: string

  /**
   * 负责人
   */
  @Column({ name: 'contact_person' })
  public contactPerson!: string

  /**
   * 公共交通
   */
  @Column({ name: 'public_transport' })
  public publicTransport!: string

  /**
   * 停车场
   */
  @Column({ name: 'parking_lot' })
  public parkingLot!: string

  /**
   * 营业时间
   */
  @Column({ name: 'business_time' })
  public businessTime!: string

  /**
   * 营业状态
   */
  @Column({ name: 'business_status' })
  public businessStatus!: number

  /**
   * 展车列表
   */
  @Column({ name: 'exhibition_vehicle_list', childType: ResourcesVehicleModel })
  public exhibitionVehicleList!: ResourcesVehicleModel[]

  /**
   * 试驾车列表
   */
  @Column({ name: 'test_drive_vehicle_list', childType: ResourcesVehicleModel })
  public testDriveVehicleList!: ResourcesVehicleModel[]

  /**
   * 关联试驾点列表
   */
  @Column({ name: 'test_drive_list', childType: ResourcesModel })
  public testDriveList!: ResourcesModel[]

  /**
   * 关联门店列表
   */
  @Column({ name: 'nio_store_list', childType: ResourcesModel })
  public nioStoreList!: ResourcesModel[]

  /**
   * 交接门店列表
   */
  @Column({ name: 'transfer_site_list', childType: ResourcesModel })
  public transferSiteList!: ResourcesModel[]

  /**
   * 资源类型，用来判断是否要显示数字孪生btn
   */
  @Column()
  public model?: string

  /**
   * 20240523 - 新增联系电话
   */
  @Column()
  public phone?: string

  /**
   * 20240620 - 交接门店备注
   */
  @Column()
  public transferSiteNote?: string

  /**
   * 位置
   */
  @Column()
  public location?: string

  // ----------------- 20241226 -----------------
  /**
   * 交接门店列表
   */
  @Column({ name: 'transfer_site_group', childType: TransferSiteGroupItem })
  public transferSiteGroup!: TransferSiteGroupItem[]

  @Column({ name: 'transfer_group_code' })
  public transferGroupCode!: string

  @Column({ name: 'transfer_group_name' })
  public transferGroupName!: string
  //---------------------END-----------------------

  // ----------------- 20260618 -----------------
  /**
   * 队列+同事
   * https://nio.feishu.cn/wiki/QJL3wYVaUiiCN3kduZ4cmGXBnIc
   */
  @Column({ name: 'handover_type' })
  public handoverType!: number // 交接类型:1=同事,2=队列

  @Column({ name: 'handover_code' })
  public handoverCode!: string // 交接对象 Code：队列Code/同事域账号

  @Column({ name: 'handover_name' })
  public handoverName!: string // 交接对象名称：队列名称 /同事姓名
  //---------------------END-----------------------
}
